import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'
import { useDispatch, useSelector } from 'react-redux'
import { editSupplyBillsFiltersAgreeEconomist } from '../../../../../store/supplyBillSlice'

const SupplyBillIsFilterAgreeEconomist = () => {

	const agree = useSelector(state => state.supplyBill.supplyBills.filters.agreeEconomist)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(agree)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: '',
			name: 'Скинути'
		},
		{
			id: 'all-true',
			name: 'Погоджено всі'
		},
		{
			id: 'any-true',
			name: 'Погоджено хоча б 1'
		},
		{
			id: 'all-false',
			name: 'Не погоджено всі'
		},
		{
			id: 'any-false',
			name: 'Не погоджено хоча б 1'
		},
		{
			id: 'all-null',
			name: 'Очікує всі'
		},
		{
			id: 'any-null',
			name: 'Очікує хоча б 1'
		},
	])

  return (
    <MySelect
        value={value}
        label="Погодження економістом"
        labelId="select__filterAgreeEconomist-label"
        id='select__filterAgreeEconomist'
        onChange = {e => {
            setValue(e)
			dispatch(editSupplyBillsFiltersAgreeEconomist(e))
			// setEvent({...event, categoryId: e})
		}}
        nameField='Погодження економістом'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplyBillIsFilterAgreeEconomist